<template>
    <v-container app :fluid="true" class="pt-0">
        <v-row>
            <v-col cols="6">
                <v-text-field
                    v-model="search"
                    append-icon="fas fa-search"
                    label="Buscar activo"
                    hide-details
                    solo
                    dense
                ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-btn @click="$refs.createOrUpdate.showForm('Nuevo activo', 'create')" 
                    rised 
                    color="indigo" 
                    dark 
                    height="36" 
                    class="float-right"
                    v-if="verifyPermission('crear_activos')">
                    <v-icon dark left size="12">fas fa-plus</v-icon>Nuevo activo
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="pt-0">
                <v-card>
                    <v-data-table
                        class="wost-table"
                        :headers="headers"
                        :items="assets"
                        item-key="name"
                        :search="search"
                        height="65vh"
                        v-if="verifyPermission('listar_activos')"
                    >   
                        <template v-slot:item.name="{ item }">
                            {{ item.name }}
                            <span :class="'status-' + item.status.toLowerCase()">{{ item.status }}</span>
                        </template>                          
                        <template v-slot:item.unit_id="{ item }">
                            <span v-if="item.unit">{{ item.unit.name }}</span>                                    
                        </template>
                        <template v-slot:item.useful_life="{ item }">
                            {{ item.useful_life }} años
                        </template>
                        <template v-slot:item.action="{ item }">
                            <div class="datatable-cell-wrapper">
                                <a href="#" title="Editar" class="btn-actions btn-edit" 
                                    @click="editAsset(item)"
                                    v-if="verifyPermission('actualizar_activos')">
                                    <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                                </a>
                                &nbsp;
                                <a v-if="item.status  === 'activo' && verifyPermission('inactivar_activos')" 
                                    href="#" title="Inactivar" 
                                    class="btn-actions btn-delete"
                                        @click="changeStatus(item, 'inactivar')">
                                    <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                                </a>
                                <a v-else-if="item.status  === 'inactivo' && verifyPermission('activar_activos')"
                                    href="#" title="Activar" 
                                    class="btn-actions btn-delete" 
                                    @click="changeStatus(item, 'activar')">
                                    <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                                </a>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <create-or-update ref="createOrUpdate" />
    </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import CreateOrUpdate from '../components/Assets/CreateOrUpdate'

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'Assets',
    components: {
        CreateOrUpdate
    },
    computed: {
        ...mapState('assets', [
            'assets',
            'asset'
        ]),
    },
    data() {
        return {
            search: '',
            headers: [
                { text: 'Nombre', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Descripción', value: 'description', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Und. de medida', value: 'unit_id', align: 'left', sortable: false, class: 'header-table', width: 140 },
                { text: 'Vida útil', value: 'useful_life', align: 'a-right', sortable: false, class: 'header-table', width: 110 },
                { text: 'Cantidad', value: 'quantity', align: 'a-right', sortable: false, class: 'header-table', width: 170 },
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 },
                { text: '', value: 'data-table-expand', width: 10, class: 'header-table-expand' }
            ]
        }
    },
    methods: {
        ...mapActions('assets', [
            'getAssets',
            'inactivateAsset'
        ]),
        ...mapMutations('assets', [
            'setAsset',
            'setAssetId'
        ]),
        editAsset(item) {
            this.setAsset(item)
            this.$refs.createOrUpdate.showForm('Modificar datos de activo', 'update')
        },
        changeStatus(item, status) {
            this.setAssetId(item.id)
            this.$swal({
                    title: "¿Desea confirmar?",
                    text: "Confirma que desea " + status + " el activo",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                }).then(async (result) => {
                    if(result.value){
                        if(result.value === true){
                            await this.inactivateAsset();
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                title: 'ACTUALIZACIÓN DE ACTIVO',
                                text: 'El estado del activo se actualizó de forma correcta'
                            });
                        }
                    }                    
                })
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getAssets()
    }
}
</script>

<style scoped>

</style>